import { tint } from 'polished'
import styled from 'styled-components'

import { type IProgressProps } from '..'

export interface IProgressStyledProps extends IProgressProps {}

export const ProgressStyled = styled.div<IProgressStyledProps>`
  width: 100%;

  ${(props) =>
    props.theme.colors[props.color] &&
    `.MuiLinearProgress-barColorPrimary {
    background-color: ${props.theme.colors[props.color]};
  }
  .MuiLinearProgress-colorPrimary:not(.MuiLinearProgress-buffer) {
    background-color: ${tint(0.6, props.theme.colors[props.color])};
  }
  .MuiLinearProgress-dashedColorPrimary {
    background-image: radial-gradient(${tint(
      0.6,
      props.theme.colors[props.color]
    )} 0%, ${tint(0.6, props.theme.colors[props.color])} 16%, transparent 42%);
  }
  `}

  ${(props) =>
    props.striped &&
    `.bar {
      background-image: repeating-linear-gradient( 45deg, transparent, transparent 5px, ${
        props.theme.colors.white
      } 5px, ${props.theme.colors.white} 10px );
      border: 1px solid ${
        props.theme.colors[props.color]
          ? props.theme.colors[props.color]
          : props.theme.colors.content.border
      };
    }`}
`
